"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _styles2 = require("@material-ui/core/styles");

var _LoadingIndictor = _interopRequireDefault(require("../LoadingIndictor"));

var _LanguageSwitcher = _interopRequireDefault(require("../LanguageSwitcher"));

var _NavList = require("../NavList");

var _AdminLayout = _interopRequireDefault(require("../AdminLayout"));

var _Router = _interopRequireDefault(require("../Router"));

var _Header = _interopRequireDefault(require("./Header"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _LoginAndForgottenPassForm = _interopRequireDefault(require("../LoginAndForgottenPassForm"));

var _LoginLayout = _interopRequireDefault(require("../LoginLayout"));

var _defaultValidator = require("./defaultValidator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var headerProps = {
  color: 'primary',
  menuButtonProps: {
    style: {
      color: '#FFFFFF'
    }
  }
};

var Kit = function Kit(props) {
  var theme = (0, _styles2.createMuiTheme)(props.theme);
  var AdminComponent = props.adminComponent || _AdminLayout.default;
  var LoginComponent = props.loginComponent || _LoginLayout.default;
  return _react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, _react.default.createElement(_react.Suspense, {
    fallback: _react.default.createElement(_LoadingIndictor.default, null)
  }, props.isUserLoggedIn ? _react.default.createElement(AdminComponent, _extends({
    header: _react.default.createElement(_Header.default, _extends({
      label: props.appTitle,
      routes: props.profileMenuRoutes,
      languages: props.languages,
      userAvatarSrc: props.userAvatarSrc
    }, props.headerProps)),
    headerProps: headerProps,
    nav: function nav(_ref) {
      var setOpened = _ref.setOpened;
      return _react.default.createElement(_Nav.default, _extends({
        routes: props.mainMenuRoutes,
        setOpened: setOpened
      }, props.navProps));
    },
    content: props.adminContent || _react.default.createElement(_Router.default, _extends({
      history: props.history,
      routes: props.routerRoutes
    }, props.routerProps)),
    footer: props.footer
  }, props.adminProps)) : _react.default.createElement(LoginComponent, _extends({
    header: props.languages ? _react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, _react.default.createElement(_LanguageSwitcher.default, _extends({
      noLabel: true,
      languages: props.languages
    }, props.languageSwitcherProps))) : null,
    aside: props.loginAside,
    content: props.loginContent || _react.default.createElement(_LoginAndForgottenPassForm.default, _extends({
      onLoginSubmit: props.onLoginSubmit,
      onForgottenPassSubmit: props.onForgottenPassSubmit,
      createValidator: props.createValidator || _defaultValidator.createValidator
    }, props.loginFormProps)),
    footer: props.footer
  }, props.loginProps)), props.children));
};

Kit.propTypes = {
  footer: _propTypes.default.node,
  children: _propTypes.default.node,
  loginAside: _propTypes.default.node,
  appTitle: _propTypes.default.node,
  routerRoutes: _NavList.routesPropType,
  loginComponent: _propTypes.default.func,
  adminComponent: _propTypes.default.func,
  mainMenuRoutes: _NavList.routesPropType,
  userAvatarSrc: _propTypes.default.string,
  createValidator: _propTypes.default.func,
  profileMenuRoutes: _NavList.routesPropType,
  theme: _propTypes.default.object.isRequired,
  history: _propTypes.default.object.isRequired,
  isUserLoggedIn: _propTypes.default.bool.isRequired,
  onLoginSubmit: _propTypes.default.func.isRequired,
  onForgottenPassSubmit: _propTypes.default.func.isRequired,
  languages: _propTypes.default.arrayOf(_propTypes.default.exact({
    code: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  headerProps: _propTypes.default.object,
  navProps: _propTypes.default.object,
  routerProps: _propTypes.default.object,
  adminProps: _propTypes.default.object,
  languageSwitcherProps: _propTypes.default.object,
  loginFormProps: _propTypes.default.object,
  loginProps: _propTypes.default.object,
  adminContent: _propTypes.default.node,
  loginContent: _propTypes.default.node
};
var _default = Kit;
exports.default = _default;